import { apiFetch } from "./http"

export type TeamMember = {
  id: number
  name: string | null
  phone: string
  role: string
  status: string
  created_at: string | null
}

export type TeamResponse = {
  members: TeamMember[]
  seats: { used: number; max: number }
}

// Demo-mode data lives here so the Team panel works in the walkthrough.
const demoMembers: TeamMember[] = [
  {
    id: 1,
    name: "Dave",
    phone: "+15550001234",
    role: "member",
    status: "active",
    created_at: "2026-07-01T00:00:00Z",
  },
]
let demoNextId = 2

function demoResponse(): TeamResponse {
  const active = demoMembers.filter((m) => m.status === "active")
  return { members: [...demoMembers], seats: { used: active.length, max: 5 } }
}

function delay<T>(value: T, ms = 140): Promise<T> {
  return new Promise((resolve) => setTimeout(() => resolve(value), ms))
}

function authHeaders(token?: string | null): HeadersInit {
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export async function listTeamMembers(demo: boolean, token?: string | null): Promise<TeamResponse> {
  if (demo) return delay(demoResponse())
  return apiFetch<TeamResponse>("/api/team/members", { headers: authHeaders(token) })
}

export async function addTeamMember(
  demo: boolean,
  payload: { phone: string; name?: string | null },
  token?: string | null,
): Promise<TeamResponse> {
  if (demo) {
    demoMembers.push({
      id: demoNextId++,
      name: payload.name || null,
      phone: payload.phone,
      role: "member",
      status: "active",
      created_at: new Date().toISOString(),
    })
    return delay(demoResponse())
  }
  return apiFetch<TeamResponse>("/api/team/members", {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeaders(token) },
    body: JSON.stringify(payload),
  })
}

export async function removeTeamMember(
  demo: boolean,
  memberId: number,
  token?: string | null,
): Promise<TeamResponse> {
  if (demo) {
    const idx = demoMembers.findIndex((m) => m.id === memberId)
    if (idx >= 0) demoMembers.splice(idx, 1)
    return delay(demoResponse())
  }
  return apiFetch<TeamResponse>(`/api/team/members/${memberId}`, {
    method: "DELETE",
    headers: authHeaders(token),
  })
}
